export default {
  title: 'Dane płatności zweryfikowane',
  description: 'Twoje dane płatności zostały pomyślnie zweryfikowane.',
};
